import {enrichContradictionSegment} from '../../../utils/contradictionGroups';
import {buildCitationFromEvidence} from './buildCitationFromEvidence';

function buildSegmentRow(group, seg) {
    const enriched = enrichContradictionSegment(seg);
    const corpusEntry = {
        referenceId: enriched.referenceId,
        docId: enriched.docId,
        segmentIndex: enriched.segmentIndex,
        segmentId: enriched.segmentId,
        text: enriched.text,
        docTitle: enriched.docTitle,
    };

    const citation = buildCitationFromEvidence({
        reference: null,
        corpusEntry,
        referenceId: enriched.referenceId,
    });
    if (!citation) return null;

    citation.referenceId = enriched.referenceId;

    return {
        referenceId: enriched.referenceId,
        reference: null,
        corpusEntry,
        citation,
        groupComment: String(group.comment || ''),
        groupTheme: group.theme || null,
        contradictionScore:
            group.contradictionScore != null ? Number(group.contradictionScore) : null,
        segmentScore: enriched.segmentScore != null ? Number(enriched.segmentScore) : null,
    };
}

/**
 * Build grouped contradiction evidence for ClaimDetailsDialog.
 *
 * @param {object[]} contradictions
 * @returns {Array<{
 *   id: string|number|null,
 *   comment: string,
 *   theme: string|null,
 *   contradictionScore: number|null,
 *   segments: object[],
 * }>}
 */
export function buildContradictionEvidenceGroups(contradictions = []) {
    const groups = [];

    for (const group of contradictions || []) {
        const segments = Array.isArray(group?.segments) ? group.segments : [];
        const rows = segments
            .map((seg) => buildSegmentRow(group, seg))
            .filter(Boolean);

        if (rows.length === 0) continue;

        groups.push({
            id: group.id ?? null,
            comment: String(group.comment || ''),
            theme: group.theme || null,
            contradictionScore:
                group.contradictionScore != null ? Number(group.contradictionScore) : null,
            segments: rows,
        });
    }

    return groups;
}

/**
 * Flatten V4 contradiction groups into evidence rows (legacy helper).
 *
 * @param {object[]} contradictions
 * @returns {object[]}
 */
export function buildContradictionEvidenceRows(contradictions = []) {
    return buildContradictionEvidenceGroups(contradictions).flatMap((group) => group.segments);
}
